import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import MuiListItem from '@mui/material/ListItem';
//import MuiListItem from "@material-ui/core/ListItem";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import Person from '@mui/icons-material/Person';
import { Avatar, makeStyles, withStyles } from '@mui/material';
import { useState } from 'react';
import GridViewIcon from '@mui/icons-material/GridView';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PublicIcon from '@mui/icons-material/Public';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { ClassNames } from '@emotion/react';
import { ActivosTipoPage } from './catalogos/ActivosTipoPage';
import { ActivosPage } from './catalogos/ActivosPage';
import { UsuariosPage } from './catalogos/UsuariosPage';
import { Build, DataArray, Grid3x3, Grid4x4, Groups, ListAlt, Logout, MapsHomeWork, Person3, Report, TableBarOutlined, Task } from '@mui/icons-material';
import { DireccionesPage } from './catalogos/DireccionesPage';
import { AsuntosPage } from './asuntos/AsuntosPage';
import { ServiciosTipoPage } from './catalogos/ServiciosTipoPage';
import { AuthContext } from '../context/AuthContext';
import { PrioridadesPage } from './catalogos/PrioridadesPage';
import { CapitulosPage } from './catalogos/CapitulosPage';
import { DepartamentosPage } from './catalogos/DepartamentosPage';
import { ReporteFallasPage } from './reportefallas/ReporteFallasPage';
import { ResumenFallasPage } from './resumenfallas/ResumenFallasPage';
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);



export default function PrincipalPage() {
  const navigate = useNavigate();
  const {usuario, setLogueado} = React.useContext(AuthContext);
  const [seleccion, setSeleccion] = useState('activosTipo');

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [opcionSeleccionada, setOpcionSeleccionada] = useState('activosTipo');

  const handleDrawerOpen = () => {
    if(open==true) {
        setOpen(false);
    } else {
        setOpen(true);
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar
            style={{backgroundColor:'white', color:'black'}}
        >
              {/* <img  
                src={require("../assets/imagotipo.png") } 
                style={{
                  visibility: open ? 'hidden':'visible',
                  width:40,
                  height:40,
                  marginRight:20,
                  
                 // width:150,
                //  height:150
                }}
              /> */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: '' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div
            style={{
                display:'flex',
                flex:1,
                flexDirection:'row',
                justifyContent:'flex-end'
            }}
          >
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    marginRight:10
                }}
            >
                <NotificationsNoneIcon />
            </div>
            <div
                style={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center'
                }}
            >
                <div 
                    style={{
                        fontSize:14
                    }}
                >
                        {usuario.Nombre+' '+usuario.ApellidoPaterno}
                </div>
            </div>
            <div
                style={{
                    marginLeft:10
                }}
            >
                <Avatar>
                    <Person />
                </Avatar>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <div
            style={{
                display:'flex',
                flex:1,
                backgroundColor:'white',
                justifyContent:'center'
            }}
          >
            <img  
                src={require("../assets/logo.png") } 
                style={{
                  width:150,
                  height:'auto'
                }}
              />

          </div>
          {/* <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton> */}
        </DrawerHeader>
        {/* <Divider /> */}
        <List>
            <ListItem key='asuntos' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('asuntos'); navigate("/asuntos"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='asuntos' ? '#60318A' :'white' ,
                  color: seleccion==='asuntos' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <Task
                        style={{
                          color: seleccion==='asuntos' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Asuntos' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='reporteFallas' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('reporteFallas'); navigate("/reportefallas"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='reporteFallas' ? '#60318A' :'white' ,
                  color: seleccion==='reporteFallas' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <ListAlt
                        style={{
                          color: seleccion==='reporteFallas' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Reporte de Fallas' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='resumenFallas' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('resumenFallas'); navigate("/resumenfallas"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='resumenFallas' ? '#60318A' :'white' ,
                  color: seleccion==='resumenFallas' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <ListAlt
                        style={{
                          color: seleccion==='resumenFallas' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Resúmen de Fallas' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <Divider style={{marginBottom:5, marginTop:5, color:'purple', borderColor:'purple'}} />
            {
              usuario?.IdTipoUsuario==1 || usuario?.IdTipoUsuario==2 ? (
                <>
            <ListItem key='activosTipo' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('activosTipo'); navigate("/activosTipo"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='activosTipo' ? '#60318A' :'white' ,
                  color: seleccion==='activosTipo' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <GridViewIcon
                        style={{
                          color: seleccion==='activosTipo' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Tipos de Activo' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='serviciosTipo' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('serviciosTipo'); navigate("/serviciosTipo"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='serviciosTipo' ? '#60318A' :'white' ,
                  color: seleccion==='serviciosTipo' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <GridViewIcon
                        style={{
                          color: seleccion==='serviciosTipo' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Tipos de Servicio' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='prioridades' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('prioridades'); navigate("/prioridades"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='prioridades' ? '#60318A' :'white' ,
                  color: seleccion==='prioridades' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <GridViewIcon
                        style={{
                          color: seleccion==='prioridades' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Prioridades' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='capitulos' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('capitulos'); navigate("/capitulos"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='capitulos' ? '#60318A' :'white' ,
                  color: seleccion==='capitulos' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <GridViewIcon
                        style={{
                          color: seleccion==='capitulos' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Capitulos' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='departamentos' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('departamentos'); navigate("/departamentos"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='departamentos' ? '#60318A' :'white' ,
                  color: seleccion==='departamentos' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <GridViewIcon
                        style={{
                          color: seleccion==='departamentos' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Departamentos' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='activos' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('activos'); navigate("/activos"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='activos' ? '#60318A' :'white' ,
                  color: seleccion==='activos' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <MapsHomeWork
                        style={{
                          color: seleccion==='activos' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Instalaciones' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='usuarios' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('usuarios'); navigate("/usuarios"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='usuarios' ? '#60318A' :'white' ,
                  color: seleccion==='usuarios' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <Groups
                        style={{
                          color: seleccion==='usuarios' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Usuarios' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
            <ListItem key='direcciones' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setSeleccion('direcciones'); navigate("/direcciones"); }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='direcciones' ? '#60318A' :'white' ,
                  color: seleccion==='direcciones' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <Person
                        style={{
                          color: seleccion==='direcciones' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Direcciones' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
              </>
              ):null
                      }
            <ListItem key='cerrar' disablePadding sx={{ display: 'block' }}>
              <ListItemButton
              onClick={(e) => {setLogueado(false); navigate("/") }}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                  backgroundColor: seleccion==='cerrar' ? '#60318A' :'white' ,
                  color: seleccion==='cerrar' ? 'white':'black',
                  
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                    <Logout
                        style={{
                          color: seleccion==='cerrar' ? 'white':'black',
                        }}
                    /> 
                </ListItemIcon>
                <ListItemText primary='Cerrar' sx={{ opacity: open ? 1 : 0}} />
              </ListItemButton>
            </ListItem>
        </List>
      </Drawer>
      <Box style={{
        backgroundColor:'#FAFAFA',
        display:'flex',
        flexDirection:'column',
        flex:1,
        height:'100vh'

      }} component="main" sx={{ flexGrow: 1, justifyContent:'left' }}>
        <DrawerHeader />
      <Routes>
          <Route exact path="/activosTipo" element={<ActivosTipoPage />} />
          <Route exact path="/serviciosTipo" element={<ServiciosTipoPage />} />
          <Route exact path="/activos" element={<ActivosPage />} />
          <Route exact path="/usuarios" element={<UsuariosPage />} />
          <Route exact path="/direcciones" element={<DireccionesPage />} />
          <Route exact path="/asuntos" element={<AsuntosPage />} />
          <Route exact path="/prioridades" element={<PrioridadesPage />} />
          <Route exact path="/capitulos" element={<CapitulosPage />} />
          <Route exact path="/departamentos" element={<DepartamentosPage />} />
          <Route exact path="/reportefallas" element={<ReporteFallasPage />} />
          <Route exact path="/resumenfallas" element={<ResumenFallasPage />} />
        </Routes> 
      </Box>
    </Box>
  );
}